<template>
<!-- 渠道分佣 -->
<section class="viewContainer">
  <!-- 搜索/查询 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
    </div>
    <el-collapse-transition>
      <div v-show="show3">
        <el-form style="padding-left: 20px;">
          <div style="display: flex; margin-top: 20px;">
            <el-form-item label="订单编号：" style="display:flex;width:30%">
              <el-input v-model="vipCardName" placeholder="请输入订单编号" style="width:90%"/>
            </el-form-item>
            <el-form-item label="用户电话：" style="display:flex;width:30%">
              <el-input v-model="vipCardPhone" placeholder="请输入用户电话" maxlength="11" style="width:90%"/>
            </el-form-item>
            <el-form-item label="所属店铺：" style="display:flex;width:30%">
              <el-select v-model="ssmdId" placeholder="请选择" ref="mySelect" filterable style="width:90%">
                <el-option v-for="(item,index) in ssmdOptions" :key="index" :value="item.id" :label="item.name"/>
              </el-select>
            </el-form-item>
          </div>
          <div style="display: flex;">
            <el-form-item label="订单状态：" style="display:flex;width:30%">
              <el-select v-model="vipOrderStatusId" placeholder="请选择" ref="mySelect" style="width:90%">
                <el-option v-for="(item,index) in statusoptions" :key="index" :value="item.Id" :label="item.Name"/>
              </el-select>
            </el-form-item>
            <el-form-item label="交易时间：" style="display:flex;width:30%">
              <el-date-picker type="daterange" v-model="jysjTime" unlink-panels @change="changeTimeJysj" style="width:90%"
                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :disabled-date="disabledFutureDate" />
            </el-form-item>
            <!-- <el-form-item label="所属城市：" style="display:flex;width:30%;">
              <el-cascader placeholder="请选择城市" filterable clearable style="width:90%"
              :options="options" v-model="chengshi" @change="handleChange"/>
            </el-form-item> -->
            <el-form-item><el-button type="danger" @click="onSubmit">查询</el-button></el-form-item>
            <el-form-item><el-button type="danger" @click="onExport" style="margin-left:10px;">导出</el-button></el-form-item>
          </div>
        </el-form>
      </div>
    </el-collapse-transition>
  </div>
  <!--列表-->
  <div class="main_container">
    <section class="model_section">
      <el-col :span="24">
        <p class="model_top_title">渠道分佣</p>
      </el-col>
    </section>
    <!-- table 列表 -->
    <div class="table_container">
      <el-table :data="dataList" class="invoice_tab" stripe border>
        <el-table-column prop="num" label="序号" align="center" width="60px">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="所属店铺" align="center">
          <template scope="scope">
            <span :title="scope.row.channel_shop" :label="scope.row.channel_shop" class="spanList">{{scope.row.channel_shop}}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单编号" align="center" width="180px">
          <template scope="scope">
            <span :title="scope.row.orderno" :label="scope.row.orderno" class="spanList">{{scope.row.orderno}}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户电话" align="center">
          <template scope="scope">
            <span :title="scope.row.phone" :label="scope.row.phone" class="spanList">{{scope.row.phone}}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户邀请人" align="center">
          <template scope="scope">
            <span :title="scope.row.inviter" :label="scope.row.inviter" class="spanList">{{scope.row.inviter}}</span>
          </template>
        </el-table-column>
        <el-table-column label="交易时间" align="center" width="160px">
          <template scope="scope">
            <span :title="scope.row.pay_time" :label="scope.row.pay_time" class="spanList">{{scope.row.pay_time}}</span>
          </template>
        </el-table-column>
        <el-table-column label="实付金额" align="center">
          <template scope="scope">
            <span :title="scope.row.pay_price" :label="scope.row.pay_price" class="spanList">￥{{scope.row.pay_price}}</span>
          </template>
        </el-table-column>
        <el-table-column label="商家应得金额" align="center" width="100px">
          <template scope="scope">
            <span :title="scope.row.shop_income_price" :label="scope.row.shop_income_price" class="spanList">￥{{scope.row.shop_income_price}}</span>
          </template>
        </el-table-column>
        <el-table-column label="本单佣金" align="center" width="80px">
          <template scope="scope">
            <span class="spanList">￥{{scope.row.channel_price}}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" align="center" width="80px">
          <template scope="scope">
            <span :title="scope.row.status_name" :label="scope.row.status_name" class="spanList">{{scope.row.status_name}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="160px">
          <template scope="scope">
            <!-- <span v-if="scope.row.StatusName != '待支付' && scope.row.IsSettlement == 0" @click="showSettlement(scope.row.Id)" class="handle">
              <i class="el-icon-edit-outline"></i> 结算
            </span> -->
            <span @click="seeOrder(scope.row)" class="handle"> <i class="el-icon-view"></i> 查看 </span>
            <!-- <span @click="confirmShipment(scope.row.Id)" class="handle" v-show="scope.row.IsShowDeliver">
              <i class="el-icon-truck"></i> 发货
            </span> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="copywriting">
        <p> 平台佣金 </p>
        <p>1、会员用户消费：实付金额*会员所消费品牌平台抽佣比例-优惠券面值*优惠券设置的品牌商返佣比例</p>
        <p>2、非会员用户消费：实付金额*固定佣金比例-优惠券面值*优惠券设置的品牌商返佣比例</p>
      </div> -->
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="total" style="float:right;margin:10px 0;"/>
    </div>
  </div>

  <!-- 抽屉详情 size="50%" -->
  <el-drawer :visible.sync="dialog" :show-close= false>
    <template v-slot:title>
      <ul class="drawer_title">
        <li>订单详情</li>
        <li>{{formDetails.StatusName}}</li>
      </ul>
    </template>
    <div class="drawer_div">
      <ul class="drawer_ul">
        <li>
          <span class="watch_first">订单编号：</span>
          <span>{{formDetails.OrderNo}}</span>
        </li>
        <li>
          <span class="watch_first">创建日期：</span>
          <span>{{formDetails.CTime}}</span>
        </li>
        <li>
          <span class="watch_first">交易类别：</span>
          <span>{{formDetails.BrandName}}</span>
        </li>
        <li>
          <span class="watch_first">付款店铺：</span>
          <span>{{formDetails.BbName}}</span>
        </li>
        <li>
          <span class="watch_first">商品总价：</span>
          <span>￥{{formDetails.TotalPrice}}</span>
        </li>
        <li>
          <span class="watch_first">导购员工：</span>
          <span>{{formDetails.GuidancePhone}}</span>
        </li>
        <li>
          <span class="watch_first">用户电话：</span>
          <span>{{formDetails.UserPhone}}</span>
        </li>
        <li>
          <span class="watch_first">款项类型：</span>
          <span>{{formDetails.PaymentTypeName}}</span>
        </li>
        <li>
          <span class="watch_first">优惠信息：</span>
          <span style="display: inline-table;">
          <ul v-for="item in formDetails.CouponsInfoList" :key="item">
            <li>{{item}}</li>
          </ul>
          </span>
        </li>
        <li>
          <span class="watch_first">实付金额：</span>
          <span>￥{{formDetails.Price}}</span>
        </li>
        <li>
          <span class="watch_first">垫付金额：</span>
          <span>￥{{formDetails.Othorpayprice}}</span>
        </li>
        <li>
          <span class="watch_first">货款金额：</span>
          <span>￥{{formDetails.BbPrice}}</span>
        </li>
        <li>
          <span class="watch_first">本单佣金：</span>
          <span>￥{{formDetails.ReturnPrice}}</span>
        </li>
        <li>
          <span class="watch_first">客户邀请人：</span>
          <span>{{formDetails.UserPhone}}</span>
        </li>
        <li>
          <span class="watch_first">邀请人佣金：</span>
          <span>￥{{formDetails.GuidePrice}}</span>
        </li>
        <li>
          <span class="watch_first">纸质凭证：</span>
          <!-- @click="showDialog(itemImgUrl.VoucherUrl)" -->
          <span v-for="itemImgUrl in formDetails.VipContractVoucherList" :key="itemImgUrl.VoucherUrl">
            <el-image :src="itemImgUrl.VoucherUrl" class="imgUrl" @click="handleClickItem" :preview-src-list="[itemImgUrl.VoucherUrl]"/>
          </span>
        </li>
        <li>
          <span class="watch_first">交易备注：</span>
          <span>{{formDetails.Remark}}</span>
        </li>
        <li>
          <span class="watch_first">收货地址：</span>
          <span v-if="ShoppingAddress">{{ShoppingAddress.Name}} - {{ ShoppingAddress.Phone }} - {{ ShoppingAddress.Address }}</span>
          <span v-else>无</span>
        </li>
      </ul>
      <div class="drawer_foot">
        <!-- <el-button type="warning" @click="tuikuan(1)" v-show="formDetails.StatusId == 6">同意退款</el-button>
        <el-button type="primary" @click="tuikuan(0)" v-show="formDetails.StatusId == 6">拒绝退款</el-button>
        <el-button type="primary" @click="cxfqtk(1)" v-show="formDetails.StatusId == 9">重新发起退款</el-button> -->
        <el-button type="danger" @click="cancelForm">关 闭</el-button>
      </div>
    </div>
  </el-drawer>

  <!-- 图片查看 -->
  <el-dialog class="img" :visible.sync="isShowImageDialog" @closed="clearImg" title='图片查看'>
    <div class="imgDialog">
      <img :src="showImageUrl"/>
    </div>
  </el-dialog>
  
  <!-- 发货提示-弹框 -->
  <el-dialog title="发货提示" :visible.sync="seeFhtx" :center="true" width="30%" append-to-body>
    <div style="text-align:center;padding-bottom: 20px;">
      <p style="font-size: 18px;">确定该订单商品已经被用户取走或已配送安装了吗？</p>
      <P>温馨提示：确定发货后，订单将在14天内自动确认收货；</P>
    </div>
    <div style="text-align:center">
      <el-button @click="seeFhtx = false">取消</el-button>
      <el-button type="danger" @click="fixFh">确定</el-button>
    </div>
  </el-dialog>

  <!-- 退款审核 -->
  <el-dialog title="退款审核" :visible.sync="seeTksh" :center="true" class="add_order_cancle" width="25%">
    <el-form>
      <el-form-item label="审核备注：" style="display:flex;">
        <el-input v-model="shenmark" placeholder="请输入审核备注" maxlength="100"/>
      </el-form-item>
    </el-form>
    <div style="padding-left:0;text-align:center">
      <el-button @click="seeTksh = false">取 消</el-button>
      <el-button type="danger" @click="qdTksh()">确定</el-button>
    </div>
  </el-dialog>
  <!-- 退款审核 end -->
  
  <!-- 退款提示-弹框 -->
  <el-dialog title="退款提示" :visible.sync="seeTktx" :center="true" width="25%" append-to-body>
    <div style="text-align:center;padding-bottom: 20px;">
      <p style="font-size: 18px;">确定重新发起退款吗？</p>
    </div>
    <div style="text-align:center">
      <el-button @click="seeTktx = false">取消</el-button>
      <el-button type="danger" @click="fixTk">确定</el-button>
    </div>
  </el-dialog>

  <!-- 初始化弹框 -->
  <el-dialog title="请选择店铺" :visible.sync="dialogSksz" width="25%" center>
    <el-form class="findform">
      <el-form-item label="店铺名称：" style="display:flex;">
        <el-select v-model="enterpriseId" filterable placeholder="请选择店铺" @change="handleChangeQymc">
          <el-option v-for="item in options1" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
  
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { userIdentity, provincegetcountys, } from '../../api/newOss';
import { getTradeRecordOrderDetailById, getkind, getUpdateVIPTradeOrderPlatformIsSettlement } from "../../api/api";
import { postShopOrderExportToExcel, putDeliver, putReviewRefund, orderGetlist } from "../../api/comment";
export default {
  name: 'channelsharing',
  mixins: [alertTrends],
  props: ["menuAction"],
  data() {
    return {
      show3: true,
      dialog: false, // 抽屉详情
      timer: null,
      isShowImageDialog: false, // 图片查看
      showImageUrl: "",
      dataList: [], // 查询列表
      pageIndex: 1,
      total: 0,
      provinceId: 0,
      cityId: 0,
      options: [
        {
          value: 0,
          label: "全部"
        }
      ],
      ssmdOptions: [], // 所属店铺
      statusoptions: [], // 状态
      vipCardName: "", // 订单编号
      vipCardPhone: '', // 用户电话
      ssmdId: '', // 所属店铺
      vipOrderStatusId: 0, // 状态
      jysjTime: '', // 交易时间
      ksDate4: '', // 开始时间
      jsDate4: '', // 结束时间
      chengshi: "", // 所属城市
      formDetails: {
        StatusName: "", // 状态
        OrderNo: "", // 订单编号
        CTime: "", // 创建日期
        BrandName: "", // 交易品牌
        BbName: "", // 付款店铺
        TotalPrice: "" , // 商品总价
        UserName: "", // 客户姓名
        UserPhone: "", // 客户电话
        CouponDiscountPrice: "", // 优惠券优惠金额
        CouponsInfoList: [], // 优惠信息
        Price: "", // 实付金额
        ReturnPrice: "", // 用户返现金额
        Remark: "", // 交易备注
        GuidanceName: "", // 导购姓名
        GuidancePhone: "", // 导购电话
        VipContractVoucherList: [] // 图片集合
        
      },
      ShoppingAddress: "", // 收货地址
      queryId: '',
      orderListId: '', // 订单id
      seeFhtx: false, // 发货提示-弹框
      seeTksh: false, // 退款审核
      shenmark: '', // 审核备注
      refundVal: '', // 退款标识
      seeTktx: false, // 退款提示-弹框
      
      dialogSksz: false, // 收款设置
      enterpriseId:'',  // 店铺id
      options1: [],

    }
  },
  methods: {
    // 选择时间查询
    changeTimeJysj() {
      if(this.jysjTime+""=="null"){
        this.jysjTime = ["",""]
      }
      this.ksDate4 = this.jysjTime[0];
      this.jsDate4 = this.jysjTime[1];
    },
    // 导出
    onExport() {
      let addParams = {
        userId: localStorage.Id, // 当前操作人id
        key: this.vipCardName, // 订单编号
        phone: this.vipCardPhone, // 用户电话
        bbid: this.ssmdId, // 所属店铺id
        vipOrderStatusId: this.vipOrderStatusId, // 状态
        beginTime: this.ksDate4, // 开始时间
        endTime: this.jsDate4, // 结束时间
        cityId: this.chengshi, // 城市id
      };
      postShopOrderExportToExcel(addParams).then(data => {
        if (data.ResultCode == 1) {
          this.showAlert('导出成功', 'success');
          window.open(data.ResultObj);
        } else {
          this.showAlert('导出失败');
        }
      })
      
      // console.log("导出");
      // var addParams = [
      //   { name: "userId", value: localStorage.Id },
      //   { name: "key", value: this.vipCardName },
      //   { name: "bbid", value: this.ssmdId },
      //   { name: "vipOrderStatusId", value: this.vipOrderStatusId },
      //   { name: "beginTime", value: this.ksDate4 },
      //   { name: "endTime", value: this.jsDate4 }
      // ];
      // var url = '/VIP/VIPTradeRecordManagement/ShopOrderExportToExcel';
      // this.downLoad(url, addParams);

    },
    // 确认发货
    confirmShipment(rowId) {
      this.orderListId = rowId; // 订单id
      this.seeFhtx = true; // 二次确认弹框
    },
    // 二次确定发货
    fixFh() {
      let addParams = {
        orderId: this.orderListId, // 订单id
        userId: localStorage.Id, // 用户id
      };
      putDeliver(addParams).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('发货成功', 'success');
          this.getorder();
          this.seeFhtx = false; // 二次确认弹框
        } else {
          this.showAlert(data.resultMsg);
        }
      })
    },
    // 同意退款 & 拒绝退款
    tuikuan(val) {
      this.refundVal = val; // 退款标识
      this.seeTksh = true; // 退款审核
      this.shenmark = '';
    },
    // 二次确定-退款审核
    qdTksh() {
      if(this.shenmark == "") {
        this.showAlert('请输入审核备注');
        return false;
      }
      let addParams = {
        orderId: this.orderListId, // 订单id
        userId: localStorage.Id, // 用户id
        refundRemark: this.shenmark, // 审核备注
        statusId: this.refundVal, // 审核状态  1=通过、0=不通过
      };
      putReviewRefund(addParams).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.getorder();
          this.seeTksh = false; // 退款审核
          this.dialog = false; // 抽屉弹框 - 隐藏
        } else {
          this.showAlert(data.resultMsg);
        }
      })
    },
    // 重新发起退款
    cxfqtk(val) {
      this.refundVal = val; // 退款标识
      this.seeTktx = true;
    },
    // 二次确定退款
    fixTk() {
      let addParams = {
        orderId: this.orderListId, // 订单id
        userId: localStorage.Id, // 用户id
        refundRemark: '', // 审核备注
        statusId: this.refundVal, // 审核状态  1=通过、0=不通过
      };
      putReviewRefund(addParams).then(data => {
        if (data.resultCode == 1) {
          this.showAlert('操作成功', 'success');
          this.getorder();
          this.seeTktx = false; // 重新发起退款
          this.dialog = false; // 抽屉弹框 - 隐藏
        } else {
          this.showAlert(data.resultMsg);
        }
      })
    },

    // 查询列表
    getorder() {
      let addParams = {
        orderno: this.vipCardName, // 订单编号
        phone: this.vipCardPhone, // 用户电话
        search_shopid: this.ssmdId, // 所属店铺id
        status: this.vipOrderStatusId, // 状态
        bdate: this.ksDate4, // 开始时间
        edate: this.jsDate4, // 结束时间
        page: this.pageIndex, // 分页数据 当前页码
        size: 10, // 分页数据 每页显示条数

      };
      orderGetlist(addParams, 1, this.enterpriseId).then(data => {
        if(data.resultCode == 1){
          this.dataList = data.resultObj.list;
          this.total = data.resultObj.totalcount;
        }else{
          this.dataList = [];
          this.total = 0;
        }
      });
    },
    // 查看
    seeOrder(row, stateId) {
      this.orderListId = row.orderid; // 订单id
      this.dialog = true;
      var addParams = {
        tradeOrderId: this.orderListId
      };
      getTradeRecordOrderDetailById(addParams).then(data => {
        if(data.ResultCode == 1){
          this.formDetails = data.ResultObj;
          this.ShoppingAddress = this.formDetails.ShoppingAddress; // 收货地址
        }else{
          this.formDetails = {};
        }
      })
    },
    // 结算按钮
    showSettlement(id) {
      this.id = id;
      this.$swal({
        type:"warning",
        text:"是否确认结算?",
        showCancelButton:true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      }).then((res)=>{
        if(res.value){
          // 执行结算
          var obj = {
            operatorId: localStorage.Id,
            tradeOrderId: this.id
          };
          getUpdateVIPTradeOrderPlatformIsSettlement(obj).then((data) => {
            if(data.ResultCode == 1){
              this.showAlert('操作成功', 'success');
              this.getorder();
            } else {
              this.showAlert(data.ResultMsg);
            }
          });
        }
      })
    },
    // 关闭抽屉弹框
    cancelForm() {
      this.dialog = false;
      clearTimeout(this.timer);
    },
    // 查看图片
    showDialog(VoucherUrl) {
      this.dialog = false;
      this.isShowImageDialog = true;
      this.showImageUrl = VoucherUrl;
    },
    // 关闭查看大图
    clearImg(){
      this.dialog = true;
      this.isShowImageDialog = false;
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
    },
    // 查找省+市
    getprovince() {
      let loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        if(data.resultCode == 1){
          let that = this;
          let provinceAndCityAndarea = [];
          data.resultObj.forEach(item => {
            // 省
            let provinceData = {value:item.pid,label:item.pname,children:[]};
            provinceAndCityAndarea.push(provinceData);
            // 市
            item.citys.map(city => {
              let cityData = {value:city.cid, label:city.cname};
              provinceData.children.push(cityData);
            })
          });
          provinceAndCityAndarea.unshift({ value: 0, label: '全国',});
          that.options = provinceAndCityAndarea;
        }
      })
    },
    // 所属店铺
    handleStore() {
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        this.ssmdOptions = data.resultObj;
        // let newdata = data.resultObj;
        // let obj = {
        //   id: 0,
        //   name: "全部"
        // };
        // newdata.unshift(obj);
        // that.ssmdOptions = newdata;
      })
    },
    // 获取状态
    getorderstatus() {
      let that = this;
      var addParams = {
        tableName: "tBDVIPTradeStatus",
        keyWord: "",
        parentId: ""
      };
      getkind(addParams).then(data => {
        if(data.ResultCode == 1){
          that.statusoptions = data.ResultObj;
          let obj = {
            Id: 0,
            Name: "全部"
          };
          that.statusoptions.unshift(obj);
        }else{

        }
      });
    },
    // 重置
    fnReset() {
      this.vipCardName= "", // 订单编号
      this.vipCardPhone = '', // 用户电话
      this.ssmdId= '', // 所属店铺
      this.vipOrderStatusId= 0, // 状态
      this.ksDate4= '',
      this.jsDate4= '',
      this.chengshi= "", // 所属城市
      this.provinceId = 0;
      this.cityId = 0;
      this.queryId = '';
      // this.pageIndex = 1;
      // this.getorder();
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      this.getorder();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getorder();
    },
    // 初始化查店铺
    initEnterprise(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data.resultCode == 1) {
          if(data.resultObj.length>1){
            this.dialogSksz = true;
            this.options1 = data.resultObj;
          } else {
            this.dialogSksz = false;
            this.enterpriseId = data.resultObj[0].id; // 默认选中第一个店铺id
            this.enterpriseName = data.resultObj[0].name;
            let that = this;
            that.getorder();
            that.getprovince(); // 获取省
            that.handleStore(); // 获取所属店铺
            that.getorderstatus(); // 获取状态
            this.queryId = this.$route.query.consumptionUserId;
          }
          
        }
      })
    },
    gonext(){
      if(this.enterpriseId == ""){
        this.showAlert('请选择店铺名称');
        return false;
      }
      this.dialogSksz = false;
      let that = this;
      that.getorder();
      that.getprovince(); // 获取省
      that.handleStore(); // 获取所属店铺
      that.getorderstatus(); // 获取状态
      this.queryId = this.$route.query.consumptionUserId;
    },
    // 获取店铺名称
    handleChangeQymc(val) {
      this.options1.filter(item => {
        if(item.id == val){
          this.enterpriseName = item.name;
        }
      })
    },
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
  },
  created() {
    this.initEnterprise(); // 初始化查店铺
  }
}
</script>
<style>
.el-drawer__body {
  overflow: scroll;
}
.el-drawer__header {
  margin-bottom: 15px;
}
</style>
<style scoped>
/* 表格操作 */
.action_container {
  color: #677c9d;
  cursor: pointer;
}
.drawer_title {
  padding-left: 0;
  display: flex;
  justify-content: space-between;
}
.drawer_title>li:first-child{
  font-size: 18px;
  font-weight: bolder;
  color: #333;
}
.drawer_div {
  width: 96%;
  margin: 0 auto;
}
.drawer_ul:first-child {
  border-bottom: 2px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 5px;
}
.drawer_ul>li {
  line-height: 40px;
  font-size: 16px;
}
.drawer_ul>li>span {
  font-size: 15px;
}
.drawer_ul>li>span>img {
  width: 66px;
  height: 66px;
  margin-left: 10px;
  margin-bottom: 10px;
}
.watch_first {
  display: inline-block;
  color: #888;
  min-width: 90px;
  text-align: justify;
  text-align-last: justify;
}
.drawer_foot {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 10px;
}
.imgDialog {
  width: 100%;
  height: 360px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.imgDialog>img {
  width:auto; 
  height:auto; 
  max-width:100%; 
  max-height:100%;
  border-radius: 3px;
}
.copywriting {
  width:80%;
  float:left;
  margin-top:15px;
  margin-left:20px;
}
</style>


// WEBPACK FOOTER //
// channelsharing.vue?db5e91a0